/// <reference path="commonfactory.ts" />
/// <reference path="commonconfigprovider.ts" />

namespace Cfnc {
    "use strict";



    interface ICommonModule extends ng.IModule { }

    // create the module and define its dependencies.
    var commonModule: ICommonModule = angular.module("common", ["authentication"]);

    commonModule.provider("commonConfig", ["authenticationProvider", (authenticationProvider) => { return new CommonProvider(authenticationProvider) }]);

    commonModule.factory(CommonFactory.serviceId, ["$q", "$rootScope", "$timeout", "commonConfig", "logger", "authentication", "$routeParams",
        ($q: ng.IQService, $rootScope: ng.IRootScopeService,
            $timeout: ng.ITimeoutService, commonConfig: ICommonProvider, logger: ILogger, authentication: Security.IAuthenticationService, $routeParams: ng.route.IRouteParamsService): ICommonFactory =>
            new CommonFactory($q, $rootScope, $timeout, commonConfig, logger, authentication, $routeParams)
    ]);

    // execute bootstrapping code and any dependencies.
    commonModule.run(["$q", "$rootScope", ($q, $rootScope) => {

    }]);

}